enum MODES {
  AUTO = 'AUTO',
  MANUAL = 'MANUAL'
}

export default MODES
